import { render, staticRenderFns } from "./C3Chart.vue?vue&type=template&id=7f376f5a&"
import script from "./C3Chart.vue?vue&type=script&lang=js&"
export * from "./C3Chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports